interface ProductShotProps {
  src: string;
  alt: string;
  title: string;
  caption?: string;
}

export default function ProductShot({ src, alt, title, caption }: ProductShotProps) {
  return (
    <div className="w-full max-w-xl mx-auto">
      <div className="rounded-2xl border border-background-300/40 bg-background-950 p-3 md:p-4">
        <div className="overflow-hidden rounded-xl">
          <img src={src} alt={alt} title={title} className="w-full h-auto object-cover" />
        </div>
      </div>
      {caption && (
        <p className="mt-3 text-center text-xs md:text-sm text-foreground-600">{caption}</p>
      )}
    </div>
  );
}